var jwjURL = {
  // baseURL: 'https://jlch.lebochelian.com:8899/display-rest/',
  // imgURL: 'https://jlch.lebochelian.com:9987/UploadImageServlet',
  baseURL: 'https://jlch.lebochelian.com/',
  //baseURL: 'http://114.217.39.22:8899/',
  //baseURL: 'http://192.168.110.50:9988/',
  // imgURL: 'https://jlch.lebochelian.com/UploadImageServlet',
  imgURL: 'https://jlch.lebochelian.com/display-web/UploadImageServlet',
}

export default jwjURL